import { NgModule } from '@angular/core';
import { ConfirmModalComponent } from './confirm-modal.component';

@NgModule({
    declarations: [ ConfirmModalComponent ],
    imports: [],
    exports: [ ConfirmModalComponent ],
    providers: []
})
export class ConfirmModalModule {}